import Cookies from 'js-cookie';

// init

const cookiePrefix = 'canDo_';
const expiresHours = 24;

// text size

const zoomCookieId = cookiePrefix + 'zoom';

const decreaseTextBtns = document.querySelectorAll(
  '[data-action="decreaseText"]'
);
const increaseTextBtns = document.querySelectorAll(
  '[data-action="increaseText"]'
);
const zoomMin = 10;
const zoomMax = 13;
let zoom = Cookies.get(zoomCookieId)
  ? Number(Cookies.get(zoomCookieId))
  : zoomMin;

function applyZoom() {
  Cookies.set(zoomCookieId, zoom, { expires: expiresHours });
  document.body.style.zoom = zoom / 10;
  if (zoom === zoomMin) {
    decreaseTextBtns.forEach((el) => {
      el.disabled = true;
    });
  } else {
    decreaseTextBtns.forEach((el) => {
      el.disabled = false;
    });
  }
  if (zoom === zoomMax) {
    increaseTextBtns.forEach((el) => {
      el.disabled = true;
    });
  } else {
    increaseTextBtns.forEach((el) => {
      el.disabled = false;
    });
  }
  increaseTextBtns.forEach((el) => {
    if (zoom > zoomMin) {
      el.classList.add('is-active');
    } else {
      el.classList.remove('is-active');
    }
  });
}

increaseTextBtns.forEach((el) => {
  el.addEventListener('click', function (e) {
    zoom++;
    if (zoom > zoomMax) zoom = zoomMax;
    applyZoom();
  });
});

decreaseTextBtns.forEach((el) => {
  el.addEventListener('click', function (e) {
    zoom--;
    if (zoom < zoomMin) zoom = zoomMin;
    applyZoom();
  });
});

document.addEventListener('DOMContentLoaded', () => {
  applyZoom();
});

// desaturate

const desaturateCookieId = cookiePrefix + 'desaturate';
const desaturateBtns = document.querySelectorAll('[data-action="desaturate"]');
let desaturate = Cookies.get(desaturateCookieId) === 'true' ?? false;

function applyDesaturate() {
  if (desaturate) {
    document.body.classList.add('site--desaturate');
  } else {
    document.body.classList.remove('site--desaturate');
  }
  desaturateBtns.forEach((el) => {
    if (desaturate) {
      el.classList.add('is-active');
    } else {
      el.classList.remove('is-active');
    }
  });
  Cookies.set(desaturateCookieId, desaturate, { expires: expiresHours });
}

desaturateBtns.forEach((el) => {
  el.addEventListener('click', function (e) {
    desaturate = !desaturate;
    applyDesaturate();
  });
});

document.addEventListener('DOMContentLoaded', () => {
  applyDesaturate();
});

// contrast

const highContrastCookieId = cookiePrefix + 'highContrast';
const highContrastBtns = document.querySelectorAll(
  '[data-action="highContrast"]'
);
let highContrast = Cookies.get(highContrastCookieId) === 'true' ?? false;

function applyHighContrast() {
  if (highContrast) {
    document.body.classList.add('site--high-contrast');
  } else {
    document.body.classList.remove('site--high-contrast');
  }
  highContrastBtns.forEach((el) => {
    if (highContrast) {
      el.classList.add('is-active');
    } else {
      el.classList.remove('is-active');
    }
  });
  Cookies.set(highContrastCookieId, highContrast, { expires: expiresHours });
}

highContrastBtns.forEach((el) => {
  el.addEventListener('click', function (e) {
    highContrast = !highContrast;
    applyHighContrast();
  });
});

document.addEventListener('DOMContentLoaded', () => {
  applyHighContrast();
});

// dyslexia

const dyslexiaCookieId = cookiePrefix + 'dyslexia';
const dyslexiaBtns = document.querySelectorAll('[data-action="dyslexiaFont"]');
let dyslexia = Cookies.get(dyslexiaCookieId) === 'true' ?? false;

function applyDyslexia() {
  if (dyslexia) {
    document.body.classList.add('site--dyslexia-font');
  } else {
    document.body.classList.remove('site--dyslexia-font');
  }
  dyslexiaBtns.forEach((el) => {
    if (dyslexia) {
      el.classList.add('is-active');
    } else {
      el.classList.remove('is-active');
    }
  });
  Cookies.set(dyslexiaCookieId, dyslexia, { expires: expiresHours });
}

dyslexiaBtns.forEach((el) => {
  el.addEventListener('click', function (e) {
    dyslexia = !dyslexia;
    applyDyslexia();
  });
});

document.addEventListener('DOMContentLoaded', () => {
  applyDyslexia();
});

// reset

const resetBtns = document.querySelectorAll(
  '[data-action="resetAccessibility"]'
);

resetBtns.forEach((el) => {
  el.addEventListener('click', function (e) {
    dyslexia = false;
    applyDyslexia();
    desaturate = false;
    applyDesaturate();
    highContrast = false;
    applyHighContrast();
    zoom = zoomMin;
    applyZoom();
  });
});
